export const footwear = [
  {
    id: 1,
    item: "Ballet Boots",
    toName: "ballet-boots",
    to: "collections",
  },
  {
    id: 2,
    item: "Folk & Character shoes",
    toName: "folk-character-shoes",
    to: "collections",
  },
  {
    id: 3,
    item: "Pointe Shoes",
    toName: "pointe-shoes",
    to: "collections",
  },
  {
    id: 4,
    item: "Pre-Pointe Shoes",
    toName: "pre-pointe-shoes",
    to: "collections",
  },
  {
    id: 5,
    item: "Soft Ballet Shoes",
    toName: "soft-ballet-shoes",
    to: "collections",
  },
  {
    id: 6,
    item: "Warm-up booties",
    toName: "warm-up-booties",
    to: "collections",
  },
];

export const apparel = [
  {
    id: 1,
    item: "Adult Leotards",
    toName: "adult-leotards",
    to: "collections",
  },
  {
    id: 2,
    item: "Boys’ and Men's",
    toName: "boys-and-mens",
    to: "collections",
  },
  {
    id: 3,
    item: "Dance tights & Socks",
    toName: "dance-tights-socks",
    to: "collections",
  },
  {
    id: 4,
    item: "Heat retention wear",
    toName: "heat-retention-wear-with-sauna-effect",
    to: "collections",
  },
  {
    id: 5,
    item: "Seamless underwear",
    toName: "seamless-underwear",
    to: "collections",
  },
  {
    id: 6,
    item: "Skirts",
    toName: "skirts",
    to: "collections",
  },
  {
    id: 7,
    item: "T-Shirts",
    toName: "t-shirts",
    to: "collections",
  },
  {
    id: 8,
    item: "Tutus",
    toName: "tutus",
    to: "collections",
  },
  {
    id: 9,
    item: "Venice Dreams",
    toName: "venice-dreams",
    to: "collections",
  },
  {
    id: 10,
    item: "Warm-ups",
    toName: "warm-ups",
    to: "collections",
  },
  {
    id: 11,
    item: "Youth Leotards",
    toName: "youth-leotards",
    to: "collections",
  },
];

export const collections = [
  {
    id: 1,
    item: "35 Years of Excellence",
    toName: "35-years-of-excellence",
    to: "collections",
  },
  {
    id: 2,
    item: "Basic Collection",
    toName: "basic-collection",
    to: "collections",
  },
  {
    id: 3,
    item: "Black Label (Crimson Shadows)",
    toName: "black-label-crimson-shadows",
    to: "collections",
  },
  {
    id: 4,
    item: "Black Label Divinity",
    toName: "black-label-divinity",
    to: "collections",
  },
  {
    id: 5,
    item: "Boundless Collection",
    toName: "boundless-collection",
    to: "collections",
  },
  {
    id: 6,
    item: "Classic Excellence",
    toName: "classic-excellence",
    to: "collections",
  },
  {
    id: 7,
    item: "Monarch",
    toName: "monarch",
    to: "collections",
  },
  {
    id: 8,
    item: "Mystique",
    toName: "mystique",
    to: "collections",
  },
  {
    id: 9,
    item: "Mystique II",
    toName: "mystique-ii",
    to: "collections",
  },
  {
    id: 10,
    item: "Nikolay Academy",
    toName: "nikolay-academy",
    to: "collections",
  },
  {
    id: 11,
    item: "Radiance",
    toName: "radiance",
    to: "collections",
  },
  {
    id: 12,
    item: "Senses",
    toName: "senses",
    to: "collections",
  },
  {
    id: 13,
    item: "Venice Dreams",
    toName: "venice-dreams",
    to: "collections",
  },
];

export const accessories = [
  {
    id: 1,
    item: "All Pillows For Pointes",
    toName: "all-pillows-for-pointes",
    to: "collections",
  },
  {
    id: 2,
    item: "Bags",
    toName: "bags",
    to: "collections",
  },
  {
    id: 3,
    item: "Gifts",
    toName: "gifts",
    to: "collections",
  },
  {
    id: 4,
    item: "Hair Accessories",
    toName: "hair-accessories",
    to: "collections",
  },
  {
    id: 5,
    item: "Pointe Shoe Accessories",
    toName: "pointe-shoe-accessories",
    to: "collections",
  },
];

export const trainingTools = [
  {
    id: 1,
    item: "Training tools",
    toName: "training-tools",
    to: "collections",
  },
];

export const discounts = [
  {
    id: 1,
    item: "Final Chance",
    toName: "final-chance",
    to: "collections",
  },
];